import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ChartPieIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/chart-pie"><g id="Icon"><path d="M14.4 10.8C13.7373 10.8 13.2 10.2628 13.2 9.60004V3.60004C13.2 2.9373 13.7404 2.39104 14.3965 2.4846C18.0782 3.00961 20.9905 5.9219 21.5155 9.6036C21.609 10.2597 21.0628 10.8 20.4 10.8H14.4Z" fill="currentColor" /><path d="M9.60359 4.8846C10.2597 4.79104 10.8 5.3373 10.8 6.00004V12C10.8 12.6628 11.3373 13.2 12 13.2H18C18.6628 13.2 19.209 13.7404 19.1155 14.3965C18.5347 18.469 15.033 21.6 10.8 21.6C6.16083 21.6 2.40002 17.8392 2.40002 13.2C2.40002 8.96704 5.5311 5.46534 9.60359 4.8846Z" fill="currentColor" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ChartPieIcon;